import {AttrsSchema} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {BaseButtonAttrs, ButtonBase} from '../base/button';
import {template} from './template';
import css from './index.styl?inline';
import {ButtonBarColor} from './types';

interface ButtonBarJsxProps {
  attrs?: ButtonBarAttrs;
}

type ButtonBarAttrs = BaseButtonAttrs & Attrs;

type Attrs = {
  'arrow-next'?: boolean;
  color?: ButtonBarColor;
};

export class ButtonBar extends ButtonBase<Attrs> {
  static get attrsSchema(): AttrsSchema<ButtonBarAttrs> {
    return {
      ...super.attrsSchema,
      'arrow-next': `boolean`,
      color: `string`,
    };
  }

  get config() {
    return Object.assign(super.config, {
      css,
      template,
    });
  }
}

export const ButtonBarEl = defineAndMakeJsxFactory<ButtonBarJsxProps>(`mp-button-bar`, ButtonBar);
